import { ATTACHMENT_MAX_FILE_SIZE } from '@/utils/constants';

/** GIF is not in the frozen backend FILE_TYPE enum, so the editor keeps its own list. */
export const ALLOWED_IMAGE_MIME_TYPES: string[] = [
	'image/jpeg',
	'image/jpg',
	'image/png',
	'image/webp',
	'image/gif',
];

export const IMAGE_ACCEPT_ATTRIBUTE = ALLOWED_IMAGE_MIME_TYPES.join(',');

export const IMAGE_MIN_WIDTH_PX = 48;

export const IMAGE_UPLOAD_ERROR_TOAST = 'Failed to upload image. Please try again.';
/** Built from the limit itself so the copy can't drift from what the check enforces. */
export const IMAGE_TOO_LARGE_TOAST = `Image is too large. Max file size is ${ATTACHMENT_MAX_FILE_SIZE / 1024 / 1024}Mb.`;
export const IMAGE_UNSUPPORTED_TYPE_TOAST = 'Unsupported image type.';
